export const enum VerificationMethod {
  Veriff = 'veriff',
}
